/**
 * How much of a serving one choice contributes per guest.
 *
 * <p>A meal box built from a quarter of this and a third of that is four
 * choices at 1/4, not four whole dishes. The fraction is what the kitchen has
 * to produce; it does not change what the package costs.</p>
 */
export const PORTIONS = [
  { label: 'Whole', value: 1 },
  { label: '1/2', value: 0.5 },
  { label: '1/3', value: 0.3333 },
  { label: '1/4', value: 0.25 },
  { label: '1/5', value: 0.2 },
  { label: '1/6', value: 0.1667 },
  { label: '1/8', value: 0.125 },
] as const

export const WHOLE_PORTION = 1

/**
 * Snaps a stored decimal onto the nearest offered fraction, so a value the
 * server rounded to four places still selects the option it came from.
 */
export function nearestPortion(value: number | undefined | null): number {
  if (value == null || !Number.isFinite(value) || value <= 0) return WHOLE_PORTION
  return PORTIONS.reduce((closest, option) =>
    Math.abs(option.value - value) < Math.abs(closest.value - value) ? option : closest,
  ).value
}

/** The fraction as it reads on the card, e.g. `1/4`. */
export function portionLabel(value: number | undefined | null): string {
  const snapped = nearestPortion(value)
  return PORTIONS.find((option) => option.value === snapped)?.label ?? 'Whole'
}
